const projects = [
  {
    name: "Social Monster",
    UXDesign: ["Information Architecture", "Wireframes", "Prototyping"],
    InterfaceDesign: ["Responsive Webdesign", "Dashboard Design", "Design system", "Illustrations"],
    Branding: ["Concept & Treatment", "Storyboarding", "2D & 3D Animations", "Script Writing"],
    Credits: ["Makers Co.", "Lucas Visuals", "Mariusz Trzeciak", "Graphic Box"],
    dot: "cyan",
    textColor: "white",
    caseColor: "slate",
    navColor: "#fff",
    activeNavDotColor: "#5edde6",
    agency: "Intervi",
    client: "Social Monster",
    role: "UI/UX/Branding",
    url: "www.socialmonster.pl",
    hamburgerColor: "white",
    logoWhite: true,
    floatingColors: "dusk"
  },
  {
    name: "Brilliant Mind",
    UXDesign: ["Information Architecture", "Wireframes", "Prototyping"],
    InterfaceDesign: ["Responsive Webdesign", "Dashboard Design", "Design system", "Illustrations"],
    Branding: ["Concept & Treatment", "Storyboarding", "2D & 3D Animations", "Script Writing"],
    Credits: ["Makers Co.", "Lucas Visuals", "Mariusz Trzeciak", "Graphic Box"],
    dot: "orange",
    textColor: "white",
    agency: "Intervi",
    client: "Brilliant Mind",
    role: "UI/UX/Branding",
    hamburgerColor: "white",
  },
  {
    name: "Mercedes",
    UXDesign: ["Information Architecture", "Wireframes", "Prototyping"],
    InterfaceDesign: ["Responsive Webdesign", "Dashboard Design", "Design system", "Illustrations"],
    Branding: ["Concept & Treatment", "Storyboarding", "2D & 3D Animations", "Script Writing"],
    Credits: ["Makers Co.", "Lucas Visuals", "Mariusz Trzeciak", "Graphic Box"],
    dot: "#00c8ff",
    textColor: "white",
    agency: "Intervi",
    client: "Marcin Rumierz",
    role: "UI/UX/Branding",
    hamburgerColor: "white",
  },
  {
    name: "Nykart",
    UXDesign: ["Information Architecture", "Wireframes", "Prototyping"],
    InterfaceDesign: ["Responsive Webdesign", "Dashboard Design", "Design system", "Illustrations"],
    Branding: ["Concept & Treatment", "Storyboarding", "2D & 3D Animations", "Script Writing"],
    Credits: ["Makers Co.", "Lucas Visuals", "Mariusz Trzeciak", "Graphic Box"],
    dot: "#000",
    textColor: "white",
    specificationColor: "black",
    caseColor: "black",
    caseText: "Case study.",
    agency: "Intervi",
    client: "Nykart",
    role: "UI/UX/Branding",
    horizontalPosition: "end",
    hamburgerColor: "black",
    logoWhite: false,
    floatingColors: "sandy"
  },
  {
    name: "PizzaBox",
    UXDesign: ["Information Architecture", "Wireframes", "Prototyping"],
    InterfaceDesign: ["Responsive Webdesign", "Dashboard Design"],
    Branding: ["Concept & Treatment", "Storyboarding", "2D & 3D Animations"],
    Credits: ["Makers Co.", "Lucas Visuals", "Mariusz Trzeciak"],
    dot: "#00aaff",
    textColor: "white",
    agency: "Intervi",
    client: "Pizza Box",
    role: "UI/UX/Branding",
    hamburgerColor: "white",
  },
  {
    name: "Janczaki",
    Webpage: ['Graphic design', 'Illustration', 'UI/UX', 'Programing'],
    ContentMarketing: ['Blog content', 'Graphics', 'Social media'],
    VisualIdentification: ['Logo', 'Brand listings', 'Business cards and company letterhead'],
    BrandStrategy: ['Work schedule', 'Marketing strategy'],
    // Credits: ["Makers Co.", "Lucas Visuals", "Mariusz Trzeciak"],
    dot: "#fed41a",
    textColor: "white",
    agency: "Intervi",
    client: "Janex",
    role: "UI/UX/Branding, creative marketing, brand strategy",
    hamburgerColor: "white",
  },
  {
    name: "Matthias",
    Webpage: ['Graphic design', 'Illustration', 'UI/UX', 'Programing'],
    ContentMarketing: ['Blog content', 'Graphics', 'Social media'],
    VisualIdentification: ['Logo', 'Brand listings', 'Business cards and company letterhead'],
    BrandStrategy: ['Work schedule', 'Marketing strategy'],
    dot: "#F50103",
    textColor: "white",
    agency: "Intervi",
    client: "Matthias",
    role: "UI/UX/Branding, creative marketing, brand strategy",
    hamburgerColor: "white",
  },
  {
    name: "Streetwear",
    Webpage: ['Graphic design', 'Illustration', 'UI/UX', 'Programing'],
    ContentMarketing: ['Blog content', 'Graphics', 'Social media'],
    VisualIdentification: ['Logo', 'Brand listings', 'Business cards and company letterhead'],
    BrandStrategy: ['Work schedule', 'Marketing strategy'],
    dot: "#F3BC69",
    hover: 'street-gold',
    textColor: "#BFBFBF",
    agency: "Intervi",
    client: "Social Monster",
    role: "UI/UX/Branding, creative marketing, brand strategy",
    hamburgerColor: "white",
  },
  {
    name: "Social Monster New",
    Webpage: ['Graphic design', 'Illustration', 'UI/UX', 'Programing'],
    ContentMarketing: ['Blog content', 'Graphics', 'Social media'],
    VisualIdentification: ['Logo', 'Brand listings', 'Graphics - 2D & 3D', 'Business cards and company letterhead'],
    BrandStrategy: ['Work schedule', 'Marketing strategy'],
    dot: "#F9A1FF",
    hover: 'monster-pink',
    textColor: "white",
    agency: "Intervi",
    client: "Social Monster",
    role: "UI/UX/Branding, creative marketing, brand strategy",
    hamburgerColor: "white",
  },
];

export default projects;



// WEBPACK FOOTER //
// ./src/assets/projects.js